import axios from 'axios'

// 헤더 출고 배너 문구 store — 4 키-값을 system_configs에서 받음
// 실패 시 기본값(하드코딩과 동일) 유지 → 어떤 경우에도 배너가 깨지지 않음
const DEFAULT_TEXTS = {
    dayTitle: '지금 주문 시 당일출고 가능',
    daySubtitle: '현재 시각 {time} 주문 기준',
    nightTitle: '지금 주문 시 다음 영업일 출고',
    nightSubtitle: '평일 오후 2:30 출고 마감'
}

export default {
    namespaced: true,
    state: () => ({
        texts: { ...DEFAULT_TEXTS },
        loaded: false,
        loading: false
    }),
    getters: {
        dayTitle: (state) => state.texts.dayTitle || DEFAULT_TEXTS.dayTitle,
        daySubtitleTemplate: (state) => state.texts.daySubtitle || DEFAULT_TEXTS.daySubtitle,
        nightTitle: (state) => state.texts.nightTitle || DEFAULT_TEXTS.nightTitle,
        nightSubtitle: (state) => state.texts.nightSubtitle || DEFAULT_TEXTS.nightSubtitle
    },
    mutations: {
        SET_LOADING(state, v) { state.loading = v },
        SET_TEXTS(state, t) {
            // 빈 값은 기본값으로 채움
            state.texts = {
                dayTitle: (t && t.dayTitle) || DEFAULT_TEXTS.dayTitle,
                daySubtitle: (t && t.daySubtitle) || DEFAULT_TEXTS.daySubtitle,
                nightTitle: (t && t.nightTitle) || DEFAULT_TEXTS.nightTitle,
                nightSubtitle: (t && t.nightSubtitle) || DEFAULT_TEXTS.nightSubtitle
            }
            state.loaded = true
        }
    },
    actions: {
        async ensureLoaded({ state, commit }, { force = false } = {}) {
            if (state.loading) return
            if (!force && state.loaded) return
            commit('SET_LOADING', true)
            try {
                const res = await axios.get('/api/user/shipping-banner')
                commit('SET_TEXTS', res.data || {})
            } catch (e) {
                console.warn('[shippingBanner] 조회 실패 — 기본 문구로 fallback', e?.message)
                commit('SET_TEXTS', DEFAULT_TEXTS)
            } finally {
                commit('SET_LOADING', false)
            }
        }
    }
}

export { DEFAULT_TEXTS }
